import * as Yup from "yup";

export const SubscriptionSchema = Yup.object({
  email: Yup.string().required("Email is required"),
});
export type SubscriptionSchemaType = Yup.InferType<typeof SubscriptionSchema>;
